module.exports = __webpack_public_path__ + "static/img/bgimg5-4.317b9b1b.png";